(function () {
  'use strict';

  var root = document.getElementById('subscribe-save-page');
  if (!root) return;

  var configEl = document.getElementById('ssp-bundle-config');
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (e) {
    return;
  }

  var products = config.products || [];
  var teaGroups = config.teaGroups || [];
  var discountPct = config.discountPercent || 10;
  var bundleCount = config.bundleDealCount || 7;
  var bundlePrice = config.bundleDealPrice || 7700;
  var bundleCode = config.bundleCode || '7FOR77';
  var bundleVariantId = config.bundleVariantId || null;
  var bundleSellingPlanId = config.bundleSellingPlanId || null;
  var bundleFixedPriceCents = config.bundleFixedPriceCents || bundlePrice;
  var bundleNoStackDiscounts = config.bundleNoStackDiscounts !== false;
  var freeShipMin = config.freeShippingMin || 4900;
  var appstleBbId = config.appstleBbId || '06x5ln6Z';
  var appstleBbMin = config.appstleBbMinProducts || bundleCount;
  var appstleBundlesType = config.appstleBundlesType || 'BUILD_A_BOX';
  var appstleProxyPrefix = config.appstleProxyPrefix || 'apps/subscriptions';
  var kcupsPerBox = config.kcupsPerBox || 12;
  var prevKcupTotal = 0;
  var prevBundleQty = 0;
  var editLineKey = null;
  var editSellingPlanId = null;
  var editHydrated = false;
  // Seed from page products so subscribe is not blocked while CDN config loads or if stale.
  var appstleBabHandles = new Set(
    (config.babHandles || products.map(function (p) {
      return p.handle;
    })).filter(Boolean)
  );

  function babConfigUrl() {
    var script = document.querySelector('script[src*="subscribe-bundle-builder"]');
    if (script && script.src) {
      return script.src.replace(
        /subscribe-bundle-builder(?:-v2)?\.js(\?.*)?$/,
        'appstle-bab-config-v2.json'
      );
    }
    return '/assets/appstle-bab-config-v2.json';
  }

  function finishInit() {
    hydrateFromCart().then(function () {
      render();
    });
  }

  fetch(babConfigUrl())
    .then(function (res) {
      return res.ok ? res.json() : null;
    })
    .catch(function () {
      return null;
    })
    .then(function (babConfig) {
      if (babConfig && Array.isArray(babConfig.handles)) {
        babConfig.handles.forEach(function (handle) {
          appstleBabHandles.add(handle);
        });
      }
      finishInit();
    });
  function stripHtml(str) {
    return String(str)
      .replace(/<[^>]*>/g, '')
      .replace(/&lt;[^&]*&gt;/g, '')
      .trim();
  }

  var moneyFormat = stripHtml(config.moneyFormat || '${{amount}}');

  var state = {
    items: [],
    mode: 'subscribe',
    search: '',
    category: 'all',
    drawerOpen: false
  };

  var els = {
    picker: root.querySelector('[data-ssp-picker]'),
    pickerGroups: root.querySelector('[data-ssp-picker-groups]'),
    categoryFilters: root.querySelector('[data-ssp-category-filters]'),
    pickerSearch: root.querySelector('[data-ssp-search]'),
    pickerCount: root.querySelector('[data-ssp-picker-count]'),
    summary: root.querySelector('[data-ssp-summary]'),
    summaryItems: root.querySelector('[data-ssp-summary-items]'),
    summaryEmpty: root.querySelector('[data-ssp-summary-empty]'),
    tierBar: root.querySelector('[data-ssp-tier-bar]'),
    tierLabel: root.querySelector('[data-ssp-tier-label]'),
    tierSteps: root.querySelectorAll('[data-ssp-tier-step]'),
    kcupMeter: root.querySelector('[data-ssp-kcup-meter]'),
    kcupVisual: root.querySelector('[data-ssp-kcup-visual]'),
    kcupTotal: root.querySelector('[data-ssp-kcup-total]'),
    kcupDetail: root.querySelector('[data-ssp-kcup-detail]'),
    subtotal: root.querySelector('[data-ssp-subtotal] [data-ssp-money]'),
    estimated: root.querySelector('[data-ssp-estimated] [data-ssp-money]'),
    estimatedRow: root.querySelector('[data-ssp-estimated-row]'),
    bundleDealRow: root.querySelector('[data-ssp-bundle-deal-row]'),
    bundleDealPrice: root.querySelector('[data-ssp-bundle-deal-price] [data-ssp-money]'),
    bundleCodeNote: root.querySelector('[data-ssp-bundle-code-note]'),
    bundleLimitNote: root.querySelector('[data-ssp-bundle-limit]'),
    subscribeBlocker: root.querySelector('[data-ssp-subscribe-blocker]'),
    subscribeHint: root.querySelector('[data-ssp-subscribe-hint]'),
    shipping: root.querySelector('[data-ssp-shipping]'),
    shippingUnlocked: root.querySelector('[data-ssp-shipping-unlocked]'),
    shippingProgress: root.querySelector('[data-ssp-shipping-progress]'),
    shippingAmount: root.querySelector('[data-ssp-shipping-amount]'),
    toggleBtns: root.querySelectorAll('[data-ssp-mode]'),
    cta: root.querySelector('[data-ssp-cta]:not([data-ssp-cta-mobile])'),
    ctas: root.querySelectorAll('[data-ssp-cta]'),
    mobileCta: root.querySelector('[data-ssp-cta-mobile]'),
    mobileBarLayout: root.querySelector('.ssp-mobile-bar-layout'),
    ctaNote: root.querySelector('[data-ssp-cta-note]'),
    mobileBar: root.querySelector('[data-ssp-mobile-bar]'),
    mobileCount: root.querySelector('[data-ssp-mobile-count]'),
    mobileKcups: root.querySelector('[data-ssp-mobile-kcups]'),
    mobileTotal: root.querySelector('[data-ssp-mobile-total]'),
    drawer: root.querySelector('[data-ssp-drawer]'),
    drawerBackdrop: root.querySelector('[data-ssp-drawer-backdrop]'),
    drawerClose: root.querySelector('[data-ssp-drawer-close]'),
    drawerToggle: root.querySelector('[data-ssp-drawer-toggle]')
  };

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var formatted;
    if (moneyFormat.indexOf('{{') !== -1) {
      formatted = moneyFormat
        .replace(/\{\{\s*amount\s*\}\}/, amount)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
    } else {
      formatted = '$' + amount;
    }
    return stripHtml(formatted);
  }

  var moneyCleanLock = false;

  function isCorruptedMoneyText(text) {
    return (
      text.indexOf('<span') !== -1 ||
      text.indexOf('transcy-money') !== -1 ||
      text.indexOf('&lt;span') !== -1
    );
  }

  function setMoney(el, cents) {
    if (!el) return;
    var formatted = formatMoney(cents);
    el.setAttribute('data-money-cents', String(cents));
    el.setAttribute('data-money-label', formatted);
    el.textContent = '';
    el.setAttribute('aria-label', formatted);
  }

  function cleanCorruptedTextNodes() {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var textNodes = [];
    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }
    textNodes.forEach(function (node) {
      var text = node.textContent || '';
      if (!isCorruptedMoneyText(text)) return;
      node.textContent = stripHtml(text);
    });
  }

  function moneySpan(cents) {
    return (
      '<span class="ssp-money notranslate" translate="no" data-money-cents="' +
      cents +
      '" data-money-label="' +
      escapeAttr(formatMoney(cents)) +
      '" aria-label="' +
      escapeAttr(formatMoney(cents)) +
      '"></span>'
    );
  }

  function cleanMoneyNodes() {
    if (moneyCleanLock) return;
    moneyCleanLock = true;
    try {
      root.querySelectorAll('.ssp-money').forEach(function (el) {
        var text = el.textContent || '';
        var cents = parseInt(el.getAttribute('data-money-cents'), 10);
        if (isCorruptedMoneyText(text)) {
          if (!isNaN(cents)) {
            setMoney(el, cents);
          } else {
            var label = el.getAttribute('data-money-label');
            if (!label) {
              label = text.replace(/<[^>]+>/g, '').replace(/&lt;[^&]+&gt;/g, '').trim();
            }
            el.textContent = '';
            if (label) el.setAttribute('data-money-label', label);
          }
          return;
        }
        if (text !== '' && el.getAttribute('data-money-label')) {
          el.textContent = '';
        }
        var label = el.getAttribute('data-money-label') || '';
        if (isCorruptedMoneyText(label)) {
          el.setAttribute('data-money-label', stripHtml(label));
        }
      });

      cleanCorruptedTextNodes();
    } finally {
      moneyCleanLock = false;
    }
  }

  function scheduleMoneyCleanup() {
    [0, 400, 1200, 2500, 5000, 8000].forEach(function (ms) {
      window.setTimeout(cleanMoneyNodes, ms);
    });
    var runs = 0;
    var intervalId = window.setInterval(function () {
      cleanMoneyNodes();
      runs += 1;
      if (runs >= 15) window.clearInterval(intervalId);
    }, 2000);
  }

  function initMoneyElements() {
    root.querySelectorAll('[data-money-cents]').forEach(function (el) {
      var cents = parseInt(el.getAttribute('data-money-cents'), 10);
      if (!isNaN(cents)) setMoney(el, cents);
    });
  }

  function totalQty() {
    return state.items.reduce(function (sum, item) {
      return sum + item.qty;
    }, 0);
  }

  function totalKcups() {
    return totalQty() * kcupsPerBox;
  }

  function animateKcupTotal(target) {
    if (!els.kcupTotal) return;
    var from = prevKcupTotal;
    if (from === target) {
      els.kcupTotal.textContent = String(target);
      return;
    }
    els.kcupTotal.classList.add('is-updating');
    var start = performance.now();
    var duration = 420;
    function frame(now) {
      var progress = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = Math.round(from + (target - from) * eased);
      els.kcupTotal.textContent = String(value);
      if (progress < 1) {
        requestAnimationFrame(frame);
      } else {
        els.kcupTotal.textContent = String(target);
        els.kcupTotal.classList.remove('is-updating');
      }
    }
    requestAnimationFrame(frame);
    prevKcupTotal = target;
  }

  function renderKcupMeter() {
    var qty = totalQty();
    var kcups = totalKcups();
    var maxRows = bundleCount;
    var previousQty = prevBundleQty;
    var grew = qty > previousQty;
    var filledRows = Math.min(qty, maxRows);

    animateKcupTotal(kcups);

    if (els.kcupDetail) {
      if (qty === 0) {
        els.kcupDetail.textContent = kcupsPerBox + ' K-Cups per flavor';
      } else {
        els.kcupDetail.textContent =
          kcups +
          (kcups === 1 ? ' K-Cup total' : ' K-Cups total');
      }
    }

    if (els.kcupVisual) {
      var html = '';
      var row;
      for (row = 0; row < maxRows; row++) {
        var rowNum = row + 1;
        var filled = row < filledRows;
        var isNew = grew && row === filledRows - 1;
        var rowClasses = 'ssp-kcup-row';
        if (filled) rowClasses += ' is-filled';
        if (isNew) rowClasses += ' is-new';

        html += '<div class="' + rowClasses + '" style="--ssp-row-index:' + row + '">';
        html += '<span class="ssp-kcup-row-label">' + rowNum + '</span>';
        html += '<div class="ssp-kcup-row-dots" aria-hidden="true">';
        var d;
        for (d = 0; d < kcupsPerBox; d++) {
          var dotClasses = 'ssp-kcup-dot';
          if (filled) dotClasses += ' is-filled';
          if (isNew) dotClasses += ' is-new';
          html +=
            '<span class="' +
            dotClasses +
            '" style="--dot-index:' +
            d +
            '"></span>';
        }
        html += '</div></div>';
      }
      if (qty > maxRows) {
        html +=
          '<p class="ssp-kcup-row-more">+' +
          (qty - maxRows) * kcupsPerBox +
          ' more K-Cups</p>';
      }
      els.kcupVisual.innerHTML = html;
    }

    prevBundleQty = qty;
  }

  function subtotalCents() {
    return state.items.reduce(function (sum, item) {
      return sum + item.price * item.qty;
    }, 0);
  }

  function getTier(count) {
    if (count >= bundleCount) return 4;
    if (count >= 5) return 3;
    if (count >= 3) return 2;
    return 1;
  }

  function tierMeta(tier) {
    var tiers = config.tiers || {};
    return tiers['tier' + tier] || {};
  }

  function subscribeTotalCents() {
    var factor = (100 - discountPct) / 100;
    return Math.round(subtotalCents() * factor);
  }

  function isAtMaxCapacity() {
    return totalQty() >= bundleCount;
  }

  function canCheckoutBundle() {
    return !!(bundleVariantId && bundleSellingPlanId);
  }

  function displayTotalCents() {
    var qty = totalQty();
    if (state.mode === 'subscribe' && qty === bundleCount) {
      return bundleFixedPriceCents;
    }
    if (state.mode === 'subscribe') {
      return subscribeTotalCents();
    }
    return subtotalCents();
  }

  function expandLineUnits() {
    var units = [];
    state.items.forEach(function (item) {
      var product = findProduct(item.variantId);
      var sku = item.sku || (product && product.sku) || '';
      for (var i = 0; i < item.qty; i++) {
        units.push({
          variantId: item.variantId,
          title: item.title,
          price: item.price,
          sku: sku
        });
      }
    });
    return units;
  }

  function shortFlavorTitle(title) {
    if (!title) return '';
    var t = String(title).replace(/\s+/g, ' ').trim();
    if (t.length <= 72) return t;
    return t.slice(0, 69) + '...';
  }

  function buildFulfillmentManifest(units) {
    return units
      .map(function (unit, index) {
        var sku = unit.sku || String(unit.variantId);
        return index + 1 + '. ' + sku + ' x' + kcupsPerBox;
      })
      .join(' | ');
  }

  function buildFulfillmentNote(units) {
    return (
      'Seven Teas Build-a-Box — fulfillment pick list:\n' +
      units
        .map(function (unit, index) {
          var sku = unit.sku || String(unit.variantId);
          return (
            index +
            1 +
            '. ' +
            sku +
            ' — ' +
            shortFlavorTitle(unit.title) +
            ' (' +
            kcupsPerBox +
            ' K-Cups)'
          );
        })
        .join('\n')
    );
  }

  function partitionForBundle() {
    var units = expandLineUnits();
    var bundleUnits = units.slice(0, bundleCount);
    var extraUnits = units.slice(bundleCount);
    var extraMap = {};
    extraUnits.forEach(function (unit) {
      if (!extraMap[unit.variantId]) {
        extraMap[unit.variantId] = { variantId: unit.variantId, qty: 0 };
      }
      extraMap[unit.variantId].qty += 1;
    });
    return {
      bundleUnits: bundleUnits,
      extraItems: Object.keys(extraMap).map(function (key) {
        return extraMap[key];
      })
    };
  }

  function buildBundleProperties(units, groupId) {
    var props = {
      _bundle_type: '7FOR77_SUBSCRIBE',
      _bundle_box_count: String(units.length),
      _bundle_fixed_price: String(bundleFixedPriceCents),
      _bundle_no_discounts: 'true',
      '_appstle-bb-id': appstleBbId,
      '_appstle_bundles_type': appstleBundlesType,
      '_appstle-bb-group': groupId
    };
    var skuList = [];
    units.forEach(function (unit, index) {
      var boxNum = index + 1;
      var sku = unit.sku || '';
      var flavor = shortFlavorTitle(unit.title);
      if (sku) {
        skuList.push(sku);
      }
      props['Item ' + boxNum] = sku
        ? sku + ' — ' + flavor + ' (' + kcupsPerBox + ' K-Cups)'
        : flavor + ' (' + kcupsPerBox + ' K-Cups)';
      props['Pick ' + boxNum] = sku || String(unit.variantId);
      props['_variant_' + boxNum] = String(unit.variantId);
      if (sku) {
        props['_sku_' + boxNum] = sku;
      }
    });
    props['Fulfillment SKUs'] = skuList.join(', ');
    props['Bundle contents'] = buildFulfillmentManifest(units);
    props['_bundle_manifest'] = units
      .map(function (unit) {
        return (unit.sku || '') + ':' + unit.variantId;
      })
      .join('|');
    return props;
  }

  function findProduct(variantId) {
    return products.find(function (p) {
      return p.variantId === variantId;
    });
  }

  function parseEditLineKey() {
    try {
      var params = new URLSearchParams(window.location.search);
      var key = params.get('edit') || params.get('line') || '';
      return key ? String(key).trim() : null;
    } catch (e) {
      return null;
    }
  }

  function isSspBundleLineItem(item) {
    if (!item) return false;
    if (item.variant_id === bundleVariantId) return true;
    if (item.properties && item.properties._bundle_type === '7FOR77_SUBSCRIBE') return true;
    if (item.properties && item.properties['Item 1']) return true;
    if (item.properties && item.properties['Pick 1']) return true;
    return false;
  }

  function variantIdFromCartProperty(props, index) {
    if (!props) return null;
    var variantKey = '_variant_' + index;
    var pickKey = 'Pick ' + index;
    var raw = props[variantKey] || props[pickKey];
    if (!raw) return null;
    var parsed = parseInt(String(raw).trim(), 10);
    return isNaN(parsed) ? null : parsed;
  }

  function hydrateStateFromCartLine(line) {
    if (!line || !line.properties) return false;
    var props = line.properties;
    var hydrated = [];
    var index;
    for (index = 1; index <= bundleCount; index++) {
      var variantId = variantIdFromCartProperty(props, index);
      if (!variantId) continue;
      var product = findProduct(variantId);
      if (!product) continue;
      var existing = hydrated.find(function (entry) {
        return entry.variantId === variantId;
      });
      if (existing) {
        existing.qty += 1;
      } else {
        hydrated.push({
          variantId: product.variantId,
          title: product.title,
          sku: product.sku || '',
          price: product.price,
          image: product.image,
          url: product.url,
          sellingPlanId: product.sellingPlanId,
          qty: 1
        });
      }
    }
    if (!hydrated.length) return false;
    state.items = hydrated;
    state.mode = 'subscribe';
    if (line.selling_plan_allocation && line.selling_plan_allocation.selling_plan) {
      editSellingPlanId = line.selling_plan_allocation.selling_plan.id;
    }
    return true;
  }

  function hydrateFromCart() {
    if (editHydrated) return Promise.resolve(false);
    editLineKey = parseEditLineKey();
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart read failed');
        return res.json();
      })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var line = null;
        if (editLineKey) {
          line = items.find(function (item) {
            return item.key === editLineKey;
          });
        }
        if (!line) {
          line = items.find(isSspBundleLineItem);
        }
        if (!line) return false;
        if (!editLineKey) editLineKey = line.key;
        var ok = hydrateStateFromCartLine(line);
        editHydrated = ok;
        return ok;
      })
      .catch(function () {
        return false;
      });
  }

  function bundleQtyForVariant(variantId) {
    var item = state.items.find(function (i) {
      return i.variantId === variantId;
    });
    return item ? item.qty : 0;
  }

  function groupSortOrder(handle) {
    var group = teaGroups.find(function (g) {
      return g.handle === handle;
    });
    return group ? group.sort : 50;
  }

  function groupLabel(handle, fallback) {
    var group = teaGroups.find(function (g) {
      return g.handle === handle;
    });
    return group ? group.label : fallback || 'Other & Samplers';
  }

  function nonSubscribeItems() {
    return state.items.filter(function (item) {
      return !item.sellingPlanId;
    });
  }

  function nonBabItems() {
    if (!appstleBabHandles || appstleBabHandles.size === 0) return [];
    return state.items.filter(function (item) {
      var product = findProduct(item.variantId);
      // Pods on this page with a selling plan are subscribe-eligible even if CDN config lags.
      if (product && product.sellingPlanId) return false;
      return product && !appstleBabHandles.has(product.handle);
    });
  }

  function subscribableProductCount() {
    return products.filter(function (p) {
      return p.sellingPlanId;
    }).length;
  }

  function addItem(variantId) {
    var product = findProduct(variantId);
    if (!product) return;
    if (isAtMaxCapacity()) return;
    var existing = state.items.find(function (i) {
      return i.variantId === variantId;
    });
    if (existing) {
      existing.qty += 1;
    } else {
      state.items.push({
        variantId: product.variantId,
        title: product.title,
        sku: product.sku || '',
        price: product.price,
        image: product.image,
        url: product.url,
        sellingPlanId: product.sellingPlanId,
        qty: 1
      });
    }
    render();
  }

  function setQty(variantId, qty) {
    qty = Math.max(0, qty);
    var idx = state.items.findIndex(function (i) {
      return i.variantId === variantId;
    });
    if (idx === -1) return;
    var currentQty = state.items[idx].qty;
    var otherQty = totalQty() - currentQty;
    qty = Math.min(qty, Math.max(0, bundleCount - otherQty));
    if (qty === 0) {
      state.items.splice(idx, 1);
    } else {
      state.items[idx].qty = qty;
    }
    render();
  }

  function removeItem(variantId) {
    setQty(variantId, 0);
  }

  function normalizeTeaType(product) {
    var handle = product.teaType || 'other';
    var known = teaGroups.some(function (g) {
      return g.handle === handle;
    });
    if (known && handle !== 'other') return handle;

    var label = (product.teaTypeLabel || '').toLowerCase();
    var title = (product.title || '').toLowerCase();
    var slug = (product.handle || '').toLowerCase();
    var hay = label + ' ' + title + ' ' + slug;

    if (hay.indexOf('matcha') !== -1) return 'matcha-tea';
    if (hay.indexOf('yerba mate') !== -1 || hay.indexOf('yerba-mate') !== -1) return 'yerba-mate-tea';
    if (hay.indexOf('rooibos') !== -1) return 'rooibos-tea';
    if (hay.indexOf('chai') !== -1) return 'chai-tea';
    if (hay.indexOf('oolong') !== -1) return 'oolong-tea';
    if (hay.indexOf('white tea') !== -1) return 'white-tea';
    if (hay.indexOf('pu') !== -1 && hay.indexOf('er') !== -1) return 'puer-dark-teas';
    if (hay.indexOf('green tea') !== -1 || hay.indexOf('green-tea') !== -1) return 'green-tea';
    if (hay.indexOf('black tea') !== -1 || hay.indexOf('black-tea') !== -1 || hay.indexOf('earl grey') !== -1) {
      return 'black-red-teas';
    }
    if (
      hay.indexOf('herbal') !== -1 ||
      hay.indexOf('botanical') !== -1 ||
      hay.indexOf('caffeine-free') !== -1 ||
      hay.indexOf('decaf') !== -1 ||
      hay.indexOf('hibiscus') !== -1 ||
      hay.indexOf('chamomile') !== -1 ||
      hay.indexOf('peppermint') !== -1
    ) {
      return 'botanical-herbal-teas';
    }
    if (hay.indexOf('gift') !== -1 || hay.indexOf('sampler') !== -1 || hay.indexOf('variety') !== -1) {
      return 'other';
    }
    return handle === 'other' ? 'other' : handle;
  }

  function filteredProducts() {
    var q = state.search.trim().toLowerCase();
    return products.filter(function (p) {
      var type = normalizeTeaType(p);
      if (state.category !== 'all' && type !== state.category) return false;
      if (!q) return true;
      return (
        p.title.toLowerCase().indexOf(q) !== -1 ||
        p.handle.toLowerCase().indexOf(q) !== -1 ||
        (p.teaTypeLabel && p.teaTypeLabel.toLowerCase().indexOf(q) !== -1)
      );
    });
  }

  function groupedProducts(list) {
    var map = {};
    list.forEach(function (p) {
      var key = normalizeTeaType(p);
      if (!map[key]) {
        map[key] = {
          handle: key,
          label: groupLabel(key, p.teaTypeLabel),
          sort: groupSortOrder(key),
          products: []
        };
      }
      map[key].products.push(p);
    });
    return Object.keys(map)
      .map(function (k) {
        return map[k];
      })
      .sort(function (a, b) {
        return a.sort - b.sort || a.label.localeCompare(b.label);
      });
  }

  function availableCategories() {
    var counts = {};
    products.forEach(function (p) {
      var key = normalizeTeaType(p);
      counts[key] = (counts[key] || 0) + 1;
    });
    var groups = teaGroups
      .filter(function (g) {
        return counts[g.handle];
      })
      .map(function (g) {
        return { handle: g.handle, label: g.label, count: counts[g.handle], sort: g.sort };
      });
    Object.keys(counts).forEach(function (handle) {
      if (!groups.some(function (g) { return g.handle === handle; })) {
        groups.push({
          handle: handle,
          label: groupLabel(handle),
          count: counts[handle],
          sort: groupSortOrder(handle)
        });
      }
    });
    return groups.sort(function (a, b) {
      return a.sort - b.sort || a.label.localeCompare(b.label);
    });
  }

  function renderCategoryFilters() {
    if (!els.categoryFilters) return;
    var categories = availableCategories();
    var html =
      '<button type="button" class="ssp-category-btn' +
      (state.category === 'all' ? ' is-active' : '') +
      '" data-ssp-category="all" role="tab" aria-selected="' +
      (state.category === 'all' ? 'true' : 'false') +
      '">All (' +
      products.length +
      ')</button>';

    categories.forEach(function (cat) {
      html +=
        '<button type="button" class="ssp-category-btn' +
        (state.category === cat.handle ? ' is-active' : '') +
        '" data-ssp-category="' +
        escapeAttr(cat.handle) +
        '" role="tab" aria-selected="' +
        (state.category === cat.handle ? 'true' : 'false') +
        '">' +
        escapeHtml(cat.label) +
        ' (' +
        cat.count +
        ')</button>';
    });

    els.categoryFilters.innerHTML = html;
  }

  function renderProductCard(p) {
    var inBundle = bundleQtyForVariant(p.variantId);
    var subPrice = Math.round(p.price * (100 - discountPct) / 100);
    var canSubscribe = !!p.sellingPlanId;
    var subscribeOnly = state.mode === 'subscribe';
    var atMax = isAtMaxCapacity();
    return (
      '<article class="ssp-picker-card' +
      (canSubscribe ? '' : ' ssp-picker-card--onetime-only') +
      (subscribeOnly && !canSubscribe ? ' ssp-picker-card--dimmed' : '') +
      '" data-variant-id="' +
      p.variantId +
      '" role="listitem">' +
      '<a class="ssp-picker-media" href="' +
      escapeAttr(p.url) +
      '" aria-label="' +
      escapeAttr(p.title) +
      '">' +
      (p.image
        ? '<img src="' +
          escapeAttr(p.image) +
          '" alt="" loading="lazy" width="120" height="120">'
        : '') +
      '</a>' +
      '<div class="ssp-picker-body">' +
      '<a class="ssp-picker-title" href="' +
      escapeAttr(p.url) +
      '">' +
      escapeHtml(p.title) +
      '</a>' +
      (p.teaTypeLabel && p.teaTypeLabel !== 'Other & Samplers'
        ? '<span class="ssp-picker-type">' + escapeHtml(p.teaTypeLabel) + (p.caffeine ? ' · ' + escapeHtml(p.caffeine) : '') + '</span>'
        : (p.caffeine ? '<span class="ssp-picker-type">' + escapeHtml(p.caffeine) + '</span>' : '')) +
      (p.taste ? '<span class="ssp-picker-detail"><b>Taste</b> ' + escapeHtml(p.taste) + '</span>' : '') +
      (p.ingredients ? '<span class="ssp-picker-detail"><b>Made with</b> ' + escapeHtml(p.ingredients) + '</span>' : '') +
      (p.rating ? '<span class="ssp-picker-rating">★ ' + Number(p.rating).toFixed(1) + (p.ratingCount ? ' (' + p.ratingCount + ')' : '') + '</span>' : '') +
      '<span class="ssp-picker-badge' +
      (canSubscribe ? ' ssp-picker-badge--subscribe' : ' ssp-picker-badge--onetime') +
      '">' +
      (canSubscribe ? 'Subscribe eligible' : 'One-time only') +
      '</span>' +
      '<div class="ssp-picker-prices">' +
      '<span class="ssp-price">' +
      moneySpan(p.price) +
      '</span>' +
      '<span class="ssp-picker-sub">' +
      (canSubscribe ? moneySpan(subPrice) + ' subscribe' : 'Subscribe not available') +
      '</span>' +
      '</div>' +
      '<button type="button" class="ssp-btn ssp-btn-add" data-add="' +
      p.variantId +
      '"' +
      (atMax ? ' disabled aria-disabled="true"' : '') +
      '>' +
      (atMax ? 'Bundle full' : inBundle ? 'Add another' : '+ Add') +
      '</button>' +
      (inBundle
        ? '<span class="ssp-picker-in-bundle">' + inBundle + ' in bundle</span>'
        : '') +
      '</div></article>'
    );
  }

  function renderPicker() {
    if (!els.pickerGroups) return;
    var list = filteredProducts();

    if (els.pickerCount) {
      var countLabel = list.length + ' tea pod' + (list.length === 1 ? '' : 's');
      if (state.category !== 'all') {
        countLabel += ' · ' + groupLabel(state.category);
      }
      if (state.search.trim()) {
        countLabel += ' · search: “' + state.search.trim() + '”';
      }
      els.pickerCount.textContent = countLabel;
    }

    if (els.subscribeHint) {
      var subCount = subscribableProductCount();
      if (state.mode === 'subscribe') {
        els.subscribeHint.textContent =
          subCount +
          ' of ' +
          products.length +
          ' pods are eligible for Subscribe & Save. One-time-only pods are marked below.';
      } else {
        els.subscribeHint.textContent = '';
      }
    }

    renderCategoryFilters();

    if (list.length === 0) {
      els.pickerGroups.innerHTML =
        '<p class="ssp-picker-empty">No tea pods match your search. Try another type or clear the search box.</p>';
      return;
    }

    var groups = groupedProducts(list);
    var showHeaders = state.category === 'all' && !state.search.trim();

    els.pickerGroups.innerHTML = groups
      .map(function (group) {
        var cards = group.products.map(renderProductCard).join('');
        if (!showHeaders) {
          return '<div class="ssp-picker-grid" role="list">' + cards + '</div>';
        }
        return (
          '<section class="ssp-picker-group" data-tea-type="' +
          escapeAttr(group.handle) +
          '">' +
          '<div class="ssp-picker-group-head">' +
          '<h3 class="ssp-picker-group-title">' +
          escapeHtml(group.label) +
          '</h3>' +
          '<span class="ssp-picker-group-count">' +
          group.products.length +
          '</span>' +
          '</div>' +
          '<div class="ssp-picker-grid" role="list">' +
          cards +
          '</div></section>'
        );
      })
      .join('');
  }

  function renderSummaryItems() {
    if (!els.summaryItems) return;
    if (state.items.length === 0) {
      els.summaryItems.innerHTML = '';
      if (els.summaryEmpty) els.summaryEmpty.hidden = false;
      return;
    }
    if (els.summaryEmpty) els.summaryEmpty.hidden = true;

    els.summaryItems.innerHTML = state.items
      .map(function (item) {
        var noSub = !item.sellingPlanId;
        var atMax = isAtMaxCapacity();
        return (
          '<li class="ssp-summary-item' +
          (noSub ? ' ssp-summary-item--no-subscribe' : '') +
          '" data-variant-id="' +
          item.variantId +
          '">' +
          '<div class="ssp-summary-item-media">' +
          (item.image
            ? '<img src="' + escapeAttr(item.image) + '" alt="" width="48" height="48">'
            : '') +
          '</div>' +
          '<div class="ssp-summary-item-info">' +
          '<span class="ssp-summary-item-title">' +
          escapeHtml(item.title) +
          '</span>' +
          (noSub
            ? '<span class="ssp-summary-item-flag">One-time only — not on subscribe</span>'
            : '') +
          '<span class="ssp-summary-item-price">' +
          moneySpan(item.price * item.qty) +
          '</span>' +
          '</div>' +
          '<div class="ssp-summary-qty">' +
          '<button type="button" class="ssp-qty-btn" data-qty-minus="' +
          item.variantId +
          '" aria-label="Decrease quantity">−</button>' +
          '<span class="ssp-qty-val">' +
          item.qty +
          '</span>' +
          '<button type="button" class="ssp-qty-btn" data-qty-plus="' +
          item.variantId +
          '" aria-label="Increase quantity"' +
          (atMax ? ' disabled aria-disabled="true"' : '') +
          '>+</button>' +
          '</div>' +
          '<button type="button" class="ssp-remove-btn" data-remove="' +
          item.variantId +
          '" aria-label="Remove ' +
          escapeAttr(item.title) +
          '">×</button>' +
          '</li>'
        );
      })
      .join('');
  }

  function renderTier() {
    var qty = totalQty();
    var tier = getTier(qty);
    var meta = tierMeta(tier);

    if (els.tierLabel) {
      els.tierLabel.textContent = meta.label || '';
    }

    if (els.tierSteps) {
      els.tierSteps.forEach(function (step) {
        var stepTier = parseInt(step.getAttribute('data-ssp-tier-step'), 10);
        step.classList.toggle('is-active', stepTier <= tier);
        step.classList.toggle('is-current', stepTier === tier);
      });
    }

    if (els.tierBar) {
      var progress = Math.min(100, (qty / bundleCount) * 100);
      els.tierBar.style.setProperty('--ssp-tier-progress', progress + '%');
    }
  }

  function renderTotals() {
    var qty = totalQty();
    var sub = subtotalCents();
    var display = displayTotalCents();

    setMoney(els.subtotal, sub);

    if (els.estimatedRow) {
      els.estimatedRow.hidden = state.mode !== 'subscribe' || qty === 0 || qty === bundleCount;
    }
    setMoney(els.estimated, subscribeTotalCents());

    if (els.bundleDealRow) {
      els.bundleDealRow.hidden = !(state.mode === 'subscribe' && qty === bundleCount);
    }
    setMoney(els.bundleDealPrice, bundleFixedPriceCents);

    if (els.bundleCodeNote) {
      var bundleDeal = state.mode === 'subscribe' && qty === bundleCount;
      els.bundleCodeNote.textContent = bundleDeal
        ? 'Fixed $77/month subscription — final price. Discount codes and extra % off do not apply.'
        : 'Add exactly ' + bundleCount + ' boxes for the fixed $77/month subscription.';
      els.bundleCodeNote.hidden = qty === 0;
    }

    if (els.bundleLimitNote) {
      els.bundleLimitNote.hidden = false;
      if (qty >= bundleCount) {
        els.bundleLimitNote.textContent = 'Bundle full — ' + bundleCount + ' of ' + bundleCount + ' boxes selected.';
      } else {
        els.bundleLimitNote.textContent =
          bundleCount + ' boxes maximum · ' + qty + ' of ' + bundleCount + ' selected.';
      }
    }

    if (els.shipping) {
      var shipBase =
        state.mode === 'subscribe' && qty === bundleCount ? bundleFixedPriceCents : display;
      if (shipBase >= freeShipMin) {
        if (els.shippingUnlocked) els.shippingUnlocked.hidden = false;
        if (els.shippingProgress) els.shippingProgress.hidden = true;
        els.shipping.classList.add('is-unlocked');
      } else {
        if (els.shippingUnlocked) els.shippingUnlocked.hidden = true;
        if (els.shippingProgress) els.shippingProgress.hidden = false;
        setMoney(els.shippingAmount, Math.max(0, freeShipMin - shipBase));
        els.shipping.classList.remove('is-unlocked');
      }
    }

    if (els.mobileCount) {
      var kcups = totalKcups();
      els.mobileCount.textContent = kcups + (kcups === 1 ? ' K-Cup' : ' K-Cups');
    }
    if (els.mobileKcups) {
      els.mobileKcups.hidden = true;
    }
    setMoney(els.mobileTotal, qty > 0 ? display : 0);

    var blocked = nonSubscribeItems().concat(nonBabItems());
    var needsMore = qty < bundleCount;
    var needsPlan = !canCheckoutBundle();

    if (els.ctas.length) {
      var ctaDisabled = qty === 0 || needsMore || blocked.length > 0 || needsPlan;
      var ctaText = 'Add pods to your bundle';
      if (needsPlan) {
        ctaText = 'Subscription setup required';
      } else if (needsMore) {
        var remaining = bundleCount - qty;
        ctaText = 'Add ' + remaining + ' more box' + (remaining === 1 ? '' : 'es') + ' to subscribe';
      } else if (blocked.length > 0) {
        ctaText = 'Remove unavailable pods to subscribe';
      } else if (qty > 0) {
        ctaText = 'Subscribe — ' + bundleCount + ' for $77';
      }
      setCtaState(function (cta) {
        cta.disabled = ctaDisabled;
        cta.textContent = ctaText;
      });
    }

    if (els.mobileBarLayout) {
      els.mobileBarLayout.classList.toggle('is-bundle-ready', qty === bundleCount);
    }
    if (els.mobileCta) {
      els.mobileCta.hidden = qty !== bundleCount;
    }

    if (els.subscribeBlocker) {
      if (blocked.length > 0) {
        var names = blocked
          .map(function (item) {
            return item.title;
          })
          .slice(0, 3)
          .join(', ');
        if (blocked.length > 3) {
          names += ' +' + (blocked.length - 3) + ' more';
        }
        els.subscribeBlocker.hidden = false;
        els.subscribeBlocker.innerHTML =
          '<strong>Subscribe blocked:</strong> ' +
          escapeHtml(names) +
          ' — not available for subscription. Remove them from your bundle.';
      } else {
        els.subscribeBlocker.hidden = true;
        els.subscribeBlocker.textContent = '';
      }
    }

    if (els.ctaNote) {
      if (qty === 0) {
        els.ctaNote.textContent = 'Pick tea pods from the list to start building.';
      } else if (blocked.length > 0) {
        els.ctaNote.textContent =
          'These pods are not eligible for subscription. Remove them to finish your bundle.';
      } else if (needsPlan) {
        els.ctaNote.textContent =
          'The bundle product needs a monthly subscription plan in Shopify before checkout can complete.';
      } else if (needsMore) {
        els.ctaNote.textContent =
          'This offer is subscription only. Select exactly ' + bundleCount + ' boxes to subscribe.';
      } else {
        els.ctaNote.textContent =
          'Fixed $77/month · no codes or extra discounts · pause or cancel anytime';
      }
    }
  }

  function setCtaState(update) {
    els.ctas.forEach(function (cta) {
      update(cta);
    });
  }

  function maybeOpenDrawerOnComplete() {
    var qty = totalQty();
    if (qty === bundleCount && prevBundleQty < bundleCount) {
      if (window.matchMedia('(max-width: 1024px)').matches) {
        openDrawer();
      }
    }
    prevBundleQty = qty;
  }

  function renderModeToggle() {
    els.toggleBtns.forEach(function (btn) {
      var active = btn.getAttribute('data-ssp-mode') === state.mode;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function render() {
    renderPicker();
    renderSummaryItems();
    renderKcupMeter();
    renderTier();
    renderTotals();
    renderModeToggle();
    maybeOpenDrawerOnComplete();
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(str) {
    return escapeHtml(str).replace(/'/g, '&#39;');
  }

  function openDrawer() {
    state.drawerOpen = true;
    if (els.drawer) {
      els.drawer.classList.add('is-open');
      els.drawer.setAttribute('aria-hidden', 'false');
    }
    if (els.drawerBackdrop) els.drawerBackdrop.hidden = false;
    if (els.drawerToggle) els.drawerToggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('ssp-drawer-open');
  }

  function closeDrawer() {
    state.drawerOpen = false;
    if (els.drawer) {
      els.drawer.classList.remove('is-open');
      els.drawer.setAttribute('aria-hidden', 'true');
    }
    if (els.drawerBackdrop) els.drawerBackdrop.hidden = true;
    if (els.drawerToggle) els.drawerToggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('ssp-drawer-open');
  }

  function applyDiscountCode(code) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'discount/' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'same-origin'
    }).catch(function () {
      return null;
    });
  }

  function applyAppstleBundleDiscount(cart) {
    var discountUrl =
      '/' +
      appstleProxyPrefix +
      '/bb/api/subscription-bundlings/discount/' +
      encodeURIComponent(appstleBbId);

    return fetch(discountUrl, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ cart: cart })
    })
      .then(function (res) {
        if (!res.ok) return null;
        return res.json();
      })
      .then(function (data) {
        if (!data || !data.discountCode) return null;
        return applyDiscountCode(data.discountCode).then(function () {
          return data.discountCode;
        });
      })
      .catch(function () {
        return null;
      });
  }

  function usesBundleDeal() {
    return state.mode === 'subscribe' && totalQty() === bundleCount && canCheckoutBundle();
  }

  function addToCart() {
    if (state.items.length === 0) return;

    var qty = totalQty();
    if (qty !== bundleCount) return;

    var missing = nonSubscribeItems();
    var outsideBab = nonBabItems();
    if (missing.length || outsideBab.length) return;
    if (!canCheckoutBundle()) return;

    var partition = partitionForBundle();
    var bundleUnits = partition.bundleUnits;
    var groupId = 'ssp-' + Date.now();
    var fulfillmentNote = buildFulfillmentNote(bundleUnits);
    var manifest = buildFulfillmentManifest(bundleUnits);
    var skuCsv = bundleUnits
      .map(function (unit) {
        return unit.sku || String(unit.variantId);
      })
      .join(',');
    var payload = {
      items: [
        {
          id: bundleVariantId,
          quantity: 1,
          selling_plan: bundleSellingPlanId,
          properties: buildBundleProperties(bundleUnits, groupId)
        }
      ]
    };

    setCtaState(function (cta) {
      cta.disabled = true;
      cta.textContent = editLineKey ? 'Updating…' : 'Adding…';
    });

    function cartMutation() {
      if (editLineKey) {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({
            id: editLineKey,
            quantity: 1,
            selling_plan: bundleSellingPlanId,
            properties: payload.items[0].properties
          })
        }).then(function (res) {
          if (!res.ok) throw new Error('Cart update failed');
          return res.json();
        });
      }

      return fetch('/cart/clear.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
          });
        })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        });
    }

    cartMutation()
      .then(function () {
        return fetch('/cart.js', {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' }
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart read failed');
        return res.json();
      })
      .then(function (cart) {
        return applyAppstleBundleDiscount(cart).then(function () {
          return cart;
        });
      })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            note: fulfillmentNote,
            attributes: {
              ssp_bundle_fixed_price: String(bundleFixedPriceCents),
              ssp_no_stack_discounts: 'true',
              'Bundle pricing': 'Fixed $77/month — no additional discounts',
              'Fulfillment SKUs': skuCsv,
              'Bundle contents': manifest,
              ssp_bundle_manifest: bundleUnits
                .map(function (unit) {
                  return (unit.sku || '') + ':' + unit.variantId;
                })
                .join('|'),
              ssp_bundle_group: groupId
            }
          })
        });
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        setCtaState(function (cta) {
          cta.disabled = false;
        });
        renderTotals();
        alert('Could not add to cart. Please try again or contact support.');
      });
  }

  root.addEventListener('click', function (e) {
    var catBtn = e.target.closest('[data-ssp-category]');
    if (catBtn) {
      state.category = catBtn.getAttribute('data-ssp-category');
      renderPicker();
      return;
    }

    var addBtn = e.target.closest('[data-add]');
    if (addBtn) {
      if (addBtn.disabled || isAtMaxCapacity()) return;
      addItem(parseInt(addBtn.getAttribute('data-add'), 10));
      return;
    }

    var minus = e.target.closest('[data-qty-minus]');
    if (minus) {
      var vid = parseInt(minus.getAttribute('data-qty-minus'), 10);
      var item = state.items.find(function (i) {
        return i.variantId === vid;
      });
      if (item) setQty(vid, item.qty - 1);
      return;
    }

    var plus = e.target.closest('[data-qty-plus]');
    if (plus) {
      if (plus.disabled || isAtMaxCapacity()) return;
      var vid2 = parseInt(plus.getAttribute('data-qty-plus'), 10);
      var item2 = state.items.find(function (i) {
        return i.variantId === vid2;
      });
      if (item2) setQty(vid2, item2.qty + 1);
      return;
    }

    var remove = e.target.closest('[data-remove]');
    if (remove) {
      removeItem(parseInt(remove.getAttribute('data-remove'), 10));
      return;
    }

    var modeBtn = e.target.closest('[data-ssp-mode]');
    if (modeBtn) {
      state.mode = modeBtn.getAttribute('data-ssp-mode');
      render();
      return;
    }

    if (e.target.closest('[data-ssp-switch-onetime]')) {
      state.mode = 'onetime';
      render();
      return;
    }

    if (e.target.closest('[data-ssp-cta]')) {
      addToCart();
      return;
    }

    if (e.target.closest('[data-ssp-drawer-toggle]')) {
      openDrawer();
      return;
    }

    if (e.target.closest('[data-ssp-drawer-close]') || e.target === els.drawerBackdrop) {
      closeDrawer();
    }
  });

  if (els.pickerSearch) {
    els.pickerSearch.addEventListener('input', function () {
      state.search = els.pickerSearch.value;
      renderPicker();
    });
  }

  initMoneyElements();
  scheduleMoneyCleanup();
})();
